module.exports = "agm-map {\n  height: 300px; }\n\n.altura-carta {\n  height: 370px; }\n\ndiv.tag {\n  padding: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/pages/iglesias/ver-iglesia/ver-iglesia.component.scss
// module id = ./src/app/admin/pages/iglesias/ver-iglesia/ver-iglesia.component.scss
// module chunks = main